<!-- Clickable when the evidence carries its source: an Alert opens the alert quick-view,
     a DVIR defect opens the inspection. A manual report has nothing behind it to open. -->
<div class="contrib" [class.closed]="vm.closed" [class.manual]="vm.manual"
     [class.linkable]="linkable"
     [attr.role]="linkable ? 'button' : null"
     [attr.tabindex]="linkable ? 0 : null"
     (click)="onOpenSource()"
     (keydown.enter)="onOpenSource()">
  <div class="contrib-top">
    <span class="contrib-title">{{ vm.displayLabel }}</span>
    <span class="source-pill" [ngClass]="vm.manual ? 'manual' : vm.source === ContributionSourceTypes.Alert ? 'alert' : 'dvir'">
      {{ (vm.manual ? '@issueSourceManual' : vm.source === ContributionSourceTypes.Alert ? '@issueSourceAlert' : '@issueSourceDvir') | translate }}
    </span>
    <span *ngIf="vm.closureChipKey" class="closure-chip">{{ vm.closureChipKey | translate }}</span>
    <span *ngIf="linkable" class="contrib-chev" aria-hidden="true">&rsaquo;</span>
  </div>

  <div class="contrib-meta" *ngIf="metaLine">{{ metaLine }}</div>

  <!-- Operator reports are authored, not emitted: name the reporter when the
       activity feed identifies them, and stay generic when it can't. -->
  <div class="contrib-author" *ngIf="vm.manual">
    {{ reporterName
        ? ('@issueManualAttributionBy' | translate: { name: reporterName })
        : ('@issueManualAttribution' | translate) }}
  </div>

  <div class="contrib-pattern" *ngIf="countLine || expiryLine">
    <span *ngIf="countLine">{{ countLine }}</span>
    <span *ngIf="countLine && expiryLine"> &middot; </span>
    <span *ngIf="expiryLine">{{ expiryLine }}</span>
  </div>

  <div class="contrib-state" *ngIf="whenLine">
    <span class="state-live">{{ whenLine }}</span>
  </div>

  <div class="contrib-bottom decaying" *ngIf="vm.decaying">
    {{ '@issueDecaying' | translate }}: {{ (vm.decayReasonKey || '') | translate }}
  </div>
</div>
